import React from 'react'
import { useTranslation } from 'react-i18next'

function Experience() {
  const { t } = useTranslation()

  return (
    <section className="tc-experience-style1 section-padding-x">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="content-wrapper">
              <div className="exp-header">
                <div className="exp-num wow zoomIn" data-wow-delay="0.3s">
                  <h2 className="num marcellus">15</h2>
                  <h5 className="exp-label marcellus">
                    {t('experience.yearsOf')} <br /> {t('experience.experience')}
                  </h5>
                </div>
                <h3 className="company-title marcellus">Bijouterie RJ</h3>
              </div>

               <div className="info wow fadeInUp" data-wow-delay="0.3s">
            <div className="text marcellus">{t('experience.description')}
              
            </div>
          </div>

            </div>
          </div>

         


          <div className="col-lg-6">
            <div className="image-wrapper">
              <img
                src="../assets/images/lifestyle/about/image2.jpg"
                alt="R&J image"
                className="exp-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience
